import script from "./batch-active-form.vue?vue&type=script&setup=true&lang=js"
export * from "./batch-active-form.vue?vue&type=script&setup=true&lang=js"

import "./batch-active-form.vue?vue&type=style&index=0&id=660bfa32&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-660bfa32"]])

export default __exports__